<template>
  <SearchBar
    v-model:value="value.search"
    @update="emits('update')"
  />
  <FoldableContent
    :image="require('@/images/order_icon.png')"
    title="Order"
  >
    <Option
      v-if="trademarkOrders"
      v-model:selection="value.order"
      title="Order"
      :options="trademarkOrders"
      @update="emits('update')"
    />
  </FoldableContent>
  <Button
    title="Reset"
    :image="require('@/images/reset_icon.png')"
    @click="emits('reset')"
  />
</template>

<script setup lang="ts">
  import SearchBar from "@/components/search_bar.vue"
  import Option from "@/components/inputs/option.vue"
  import FoldableContent from "@/components/foldable_content.vue"
  import Button from "@/components/button.vue"
  import {PropType} from "vue"
  import {TrademarkInput} from "@/endpoints/rutsolve/gql/generated/types"
  
  defineProps({
    trademarkOrders: {
      default: null,
      required: false,
      type: Array<string>
    }
  })
  
  const emits = defineEmits(["reset", "update"])
  const value = defineModel("value", {
    default: null,
    required: true,
    type: Object as PropType<TrademarkInput>
  })
</script>
